import * as React from "react";

import { GeneralSalesPanel } from "../general/GeneralSalesPanel";
import "./BookinfoPremiumBestSellerPanel.scss";

// tslint:disable-next-line:no-empty-interface
export interface IBookinfoPremiumBestSellerPanelProps {}

// tslint:disable-next-line:no-empty-interface
export interface IBookinfoPremiumBestSellerPanelState {}

export class BookinfoPremiumBestSellerPanel extends React.Component<IBookinfoPremiumBestSellerPanelProps, IBookinfoPremiumBestSellerPanelState> {
    constructor(props: IBookinfoPremiumBestSellerPanelProps) {
        super(props);
    }

    public render() {

        return (
            <div>

                <GeneralSalesPanel isPremium={true} />
                
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/panel/bookinfo-premium/BookinfoPremiumBestSellerPanel.tsx